<script>
export default {
  name: 'DropdownSingle',
  emits: ['onSelectValue'],
  props: {
    propModel: String,
    propId: {
      type: String,
      default: '',
    },
    propBootstrapIcon: {
      type: String,
      default: '',
    },
    propOptionList: Array
  },
  data() {
    return {
      selected: {
        parent: null,
        value: null
      }
    }
  },
  watch: {
    propModel(newValue, oldValue) {
      this.selected.value = newValue;
    }
  },
  methods: {
    onClickSelect(value, parent) {
      this.selected.value = value;
      this.$emit('onSelectValue', value, parent);
    }
  },
  computed: {
    optionParents() {
      let optionParent = {};

      this.propOptionList.forEach(item => {
        item.children.forEach(child => {
          optionParent[child.value] = item;
        })
      });

      return optionParent;
    },
    optionItems() {
      let optionItems = {};
      this.propOptionList.forEach(item => {
        item.children.forEach(child => {
          optionItems[child.value] = child;
        })
      });
      return optionItems;
    },
    selectedParent() {
      let selectedParent = this.optionParents[this.selected.value];
      return selectedParent !== null && selectedParent !== undefined ? selectedParent : null;
    },
    selectedItem() {
      let selectedItem = this.optionItems[this.selected.value];
      return selectedItem !== null && selectedItem !== undefined ? selectedItem : null;
    }
  }
}
</script>

<template>
  <div class="dropdown-center">
    <button class="btn btn-outline-dark border-dark-subtle dropdown-toggle w-100" type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false">
      <template v-if="selectedParent !== null">
        <i v-if="selectedParent.bootstrapIcon !== ''"
           class="bi me-2"
           :class="`bi-${selectedParent.bootstrapIcon}`">
        </i>
        <div class="d-inline-block">
          <div class="fw-lighter small d-inline-block me-2">{{ selectedParent.name }}</div>
          <div class="d-inline-block">
            {{ selectedItem.name }}
          </div>
        </div>
      </template>
      <template v-else>
        <i v-if="propBootstrapIcon !== ''" class="bi me-1" :class="$`bi-${propBootstrapIcon}`"></i>
        <span>{{ $t('formDataType.select') }}</span>
      </template>
    </button>
    <ul class="dropdown-menu">
      <template v-for="(option, index) in propOptionList">
        <li>
          <h6 class="dropdown-header">
            <i v-if="option.bootstrapIcon !== ''" class="bi me-1" :class="`bi-${option.bootstrapIcon}`"></i>
            <span>{{ option.name }}</span>
          </h6>
        </li>
        <template v-for="child in option.children">
          <li>
            <button class="dropdown-item"
                    :class="{'active': child.value === selected.value}"
                    @click="onClickSelect(child.value, option.id)">
              {{ child.name }}
            </button>
          </li>
        </template>
        <li v-if="index < propOptionList.length - 1">
          <hr class="dropdown-divider">
        </li>
      </template>
    </ul>
  </div>
</template>
